module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/route-f19e62124bbe808e4b70d6443b9f4965.svg";